import { FaGithub, FaExternalLinkAlt } from "react-icons/fa";
import { Link } from "react-router-dom";
import emailjs from "@emailjs/browser";
import { useState } from "react";
import bg from "../assets/images/contact1.png";

export default function Contact() {
  const EMAILJS_SERVICE_ID = "service_3ceep8u";
  const TEMPLATE_ID = "template_o8nafs9";
  const PUBLIC_KEY = "M_zyiaeR2WM9B4pd7";

  const [status, setStatus] = useState("idle");

  const [user, setUser] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (evt) => {
    setUser((member) => ({
      ...member,
      [evt.target.name]: evt.target.value,
    }));
  };

  const handleStatusChange = (evt) => {
    setStatus("idle");
    setUser((member) => ({
      ...member,
      [evt.target.name]: evt.target.value,
    }));
  };

  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const submitHandler = async (evt) => {
    evt.preventDefault();
    if (!user.name || !user.email || !user.message) {
      setStatus("validation");
      return;
    }
    if (!isValidEmail(user.email)) {
      setStatus("invalidEmail");
      return;
    }
    try {
      await emailjs.send(
        EMAILJS_SERVICE_ID,
        TEMPLATE_ID,
        {
          name: user.name,
          email: user.email,
          message: user.message,
          title: "Message from portfolio",
        },
        PUBLIC_KEY,
      );
      setStatus("sending");
      setUser({
        name: "",
        email: "",
        message: "",
      });

      setStatus("success");
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div
      className="h-full md:p-4 bg-[#ece1cf] grid gap-4 "
      style={{
        backgroundImage: `url(${bg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
    >
      <div className="grid md:grid-cols-3 gap-4 md:gap-0">
        <div className="w-full md:space-y-5 md:m-auto p-4">
          <h1 className="md:text-3xl md:pb-2 text-lg">
            <span className="text-[#031153] ">Let's get</span>{" "}
            <span className="text-[#785042] ">in touch.</span>
          </h1>
          <p className="text-[#2d1f1a] text-xs md:text-sm">
            I'm currently available for freelance projects, internship,
            learnership
            <span className="opacity-0 sm:opacity-100">
              , collaboration, volunteering roles
            </span>
          </p>
        </div>
        <div className="w-full flex col-span-2 items-center justify-center m-auto rounded-xl gap-6 md:0">
          {/* Contact Form */}
          <div className="px-4 justify-center w-full h-full flex items-center ">
            <div className=" w-full md:w-[70%] m-auto bg-black/50  rounded-lg relative ">
              <div className="bg-[#978b72] px-4 py-5 rounded-t-lg">
                <h1 className="text-2xl font-extrabold">
                  Let's <span className="text-[#031153]">talk</span>
                </h1>
              </div>
              <form
                method="post"
                onSubmit={submitHandler}
                className="p-6 w-full "
              >
                <div className=" h-full  space-y-8 items-center gap-4">
                  <div className="flex flex-col justify-between w-full gap-7">
                    <div className="w-full">
                      <input
                        maxLength={100}
                        className="w-full h-10 p-2 rounded-lg  bg-[#4b4a4a] border-gray-300"
                        type="text"
                        placeholder="Name"
                        id="name"
                        name="name"
                        value={user.name}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="w-full">
                      <input
                        maxLength={150}
                        className="w-full h-10 p-2 rounded-lg  bg-[#4b4a4a] border-gray-300"
                        type="text"
                        placeholder="Email"
                        id="email"
                        name="email"
                        value={user.email}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="rounded-md">
                    <textarea
                      className="w-full h-40 p-2 rounded-lg  bg-[#4b4a4a] border-gray-300"
                      type="text"
                      placeholder="Message"
                      id="message"
                      name="message"
                      value={user.message}
                      maxLength={2000}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="space-y-3">
                    {status === "validation" && (
                      <p className="text-red-400 text-xs md:text-sm">
                        Please fill in all fields.
                      </p>
                    )}
                    {status === "success" && (
                      <p className="text-green-400 text-xs md:text-sm">
                        Message sent! I'll be in touch soon.
                      </p>
                    )}
                    {status === "error" && (
                      <p className="text-red-400 text-xs md:text-sm">
                        Something went wrong. Please try again.
                      </p>
                    )}
                    {status === "invalidEmail" && (
                      <p className="text-red-400 text-xs md:text-sm">
                        Please enter a valid email address.
                      </p>
                    )}
                    <button
                      type="submit"
                      disabled={status === "sending"}
                      className="px-12 py-2 bg-[#978b72] text-white rounded-md font-bold disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      {status === "sending" ? "Sending..." : "Send"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <footer className="items-center md:grid md:grid-cols-2 border-t p-4 border-[#978b72] h-full text-sm text-[#3b2f2f] ">
        <div className="flex md:pl-32 md:flex-col gap-3 ">
          <Link
            to={"https://github.com/23Mandla"}
            target="blank"
            className="hover:text-[#c78d41] transition-colors text-[#4143c7]"
          >
            GitHub
          </Link>
          <Link
            to={"https://www.linkedin.com/in/mandla-mbolekwa-a2501320a/"}
            target="blank"
            className="hover:text-[#c78d41] transition-colors text-[#4143c7]"
          >
            LinkedIn
          </Link>
          <a
            href="mailto:mandlambolekwa@gmail.com"
            target="__blank"
            className="hover:text-[#c78d41] transition-colors text-[#4143c7]"
          >
            Email
          </a>
          <Link
            to={"https://mandla.dev/blog"}
            target="blank"
            className="hover:text-[#c78d41] transition-colors text-[#4143c7]"
          >
            Blog
          </Link>
        </div>
        <div className="">
          <p>&copy; 2026 Mandla Mbolekwa. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}
